import Core from '_abstracts/core'
import ViewEvents from './elements-list-view'

Core.Tasks.add(Core.Events.PAGE_READY, () => {
    new ViewEvents()
})
